import { BaseProvider } from 'baseui';
import { HelmetProvider } from 'react-helmet-async';
import { Client as Styletron } from 'styletron-engine-monolithic';
import { Provider as StyletronProvider } from 'styletron-react';
import { AppRoutes } from './components/routing/AppRoutes';
import ErrorBoundary from './components/shared/ErrorBoundary';
import { CustomTheme } from './theme/customTheme';

const engine = new Styletron();

function App() {
  return (
    <ErrorBoundary>
      <StyletronProvider value={engine}>
        <BaseProvider theme={CustomTheme}>
          <HelmetProvider>
            <AppRoutes />
          </HelmetProvider>
        </BaseProvider>
      </StyletronProvider>
    </ErrorBoundary>
  );
}

export default App;
